import { LoadersService } from './loaders.service';
import { AppInjector } from '../services/set-app-injector';


export class LoaderMessage {
  private loadersService: any;
  private allUseLoaders: any[];
  private _loaderMessage: string;

  public showLoader = false;

  constructor(
    private loaderName: string,
    private loaderDependency: any[] = [],
  ) {
    this.loadersService = AppInjector.get(LoadersService);

    this.allUseLoaders = this.loaderDependency.concat([this.loaderName]);

    this.registerLoader();
  }

  private registerLoader() {
    this.loadersService.registerLoader(
      this.loaderName,
      this.loaderDependency
    ).subscribe( (_context: any) => {
      this.showLoader = _context.visible;
    });
  }

  public setLoaderMessage(_message:any):void {
    this._loaderMessage = _message;
  }

  public getLoaderMessage() {
    return this._loaderMessage;
  }

  public start() {
    if (!this.getLoaderMessage()) {
      console.warn('Set the text loader');

      return;
    }

    this.loadersService.start(this.loaderName);
  }

  public stop() {
    this.loadersService.stop(this.loaderName);

    this.setLoaderMessage('');
  }

}

